module.exports = __webpack_public_path__ + "img/oceanShipping-Y.68ba2874.png";